const MARKETPLACE_APP_URL = import.meta.env.VITE_WS_MARKETPLACE_APP_URL || 'https://www.wonderschool.com';

export const BASELINE_SURVEY_URL = `${MARKETPLACE_APP_URL}/ccms/baseline-survey`;
export const BASELINE_SURVEY_DASHBOARD_URL = `${MARKETPLACE_APP_URL}/ccms/baseline-survey-dashboard`;
export const BASELINE_SURVEY_STATUS_URL = `${MARKETPLACE_APP_URL}/firebase-api/baseline-survey/status`;

export function buildAuthenticatedBaselineSurveyUrl(token: string): string {
  const redirectTo = encodeURIComponent('/ccms/baseline-survey-dashboard');
  return `${MARKETPLACE_APP_URL}/exchange-token/${encodeURIComponent(token)}?redirect_to=${redirectTo}`;
}

type BaselineSurveyStatusResponse = {
  completed: boolean;
};

export async function fetchBaselineSurveyCompleted(token: string): Promise<boolean> {
  try {
    const response = await fetch(BASELINE_SURVEY_STATUS_URL, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) return false;

    const status: BaselineSurveyStatusResponse = await response.json();
    return status.completed;
  } catch {
    return false;
  }
}
